import ReactPlayer from "react-player";

import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import db from "../firebase";
import styled from "styled-components";

const Player = (props) => {
  const { id } = useParams();
  const [detailData, setDetailData] = useState({});

  useEffect(() => {
    db.collection("movies")
      .doc(id)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setDetailData(doc.data());
        } else {
          console.log("no such document in firebase 🔥");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  }, [id]);

  return (
    <Container>
      <ReactPlayer
        className="react-player fixed-bottom"
        url={detailData.videourl}
        width="100%"
        height="100%"
        controls={true}
      />

      <Powered>Powered By Srinath Dev</Powered>
     
    </Container>
  );
};

const Powered = styled.h2`
  color: hsla(0, 0%, 95.3%, 1);

  font-size: 18px;
  line-height: 1.5;
  letter-spacing: 1.5px;
  display: inline-block;
  vertical-align: bottom;
  width: 100%;
`;

const Container = styled.section`
  
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100vh;
`;

const Srinathdev = styled.img`

  display: block;
  width: 100%;
  display: "flex",
 justifyContent: "center";
`;

export default Player;
